// @ts-nocheck
// @todo refactor and fix type

import React, { useMemo, ReactNode, ReactNodeArray, useContext } from 'react';
import { NavLink, useLocation, matchPath } from 'react-router-dom';
import _ from 'lodash';
import { Menu, Skeleton, Card } from 'antd';
import {
  UserOutlined,
  SolutionOutlined,
  ContainerOutlined,
  ContactsOutlined,
  HomeOutlined,
  ToolOutlined,
} from '@ant-design/icons';

import config, { Project } from 'app.config';
import { getUrlParamsBySearch, stringifyUrlParams } from 'method';
import { PAGE_TITLE } from 'constants/content';
import { useUserPermissionMap } from 'hooks/login';
import { permissions } from 'constants/permissions';
import { UserContext } from 'routes/login/userContext';

const { publicUrl, project } = config;
const SubMenu = Menu.SubMenu;

interface MenuConfig {
  key: string;
  label: string;
  icon?: ReactNode;
}

type UrlParams = { [key: string]: string | string[] };
interface SidebarSubMenu extends MenuConfig {
  path: string;
  permission?: string;
  params?: UrlParams;
  weigh?: (urlParams: UrlParams, menuParams: UrlParams) => boolean;
  suppliers?: number[];
}

interface SidebarMenu extends MenuConfig {
  children: SidebarSubMenu[];
}

const issueStatusList = ['1', '2'];
const issueStatusConfigs = (defaultStatus = issueStatusList, type = 'order') => {
  const key = type === 'order' ? 'issue_status' : 'issue_statuses';
  return {
    params: { [key]: defaultStatus },
    weigh: (urlParams) => {
      const urlStatusList: string[] = urlParams[key];
      return _.isEmpty(urlStatusList) ? 0 : _.union(urlStatusList, issueStatusList).length;
    },
  };
};

// const tempAdmittedReturnSuppliers = [3345678];
const sidebar: SidebarMenu[] =
  project === Project.SupplyChainManagement
    ? [
        {
          key: 'Homepage',
          label: '首頁',
          icon: <HomeOutlined />,
          children: [
            {
              key: 'Announcements',
              label: '公告',
              path: `${config.publicUrl}/homepage/announcements`,
              permission: permissions.VIEW__ADMIN_ANNOUNCEMENT,
            },
            {
              key: 'Backlogs',
              label: '待辦事項',
              path: `${config.publicUrl}/homepage/backlogs`,
            },
          ],
        },
        {
          key: 'ScmAccounts',
          label: '用戶管理',
          icon: <UserOutlined />,
          children: [
            {
              key: 'Users',
              label: '使用者名單',
              path: `${config.publicUrl}/account/users`,
              permission: permissions.VIEW__ADMIN_USER,
            },
            {
              key: 'Roles',
              label: '角色管理',
              path: `${config.publicUrl}/account/roles`,
              permission: permissions.VIEW__ADMIN_ROLE,
            },
          ],
        },
        {
          key: 'ScmSku',
          label: '供應商管理',
          icon: <SolutionOutlined />,
          children: [
            {
              key: 'Suppliers',
              label: '供應商',
              path: `${config.publicUrl}/supplier/suppliers`,
              permission: permissions.VIEW__ADMIN_SUPPLIER,
            },
            {
              key: 'Skus',
              label: '商品',
              path: `${config.publicUrl}/supplier/skus`,
              permission: permissions.VIEW__ADMIN_SKU,
            },
          ],
        },
        {
          key: 'ScmShop',
          label: '商家管理',
          icon: <SolutionOutlined />,
          children: [
            {
              key: 'ShopAuthorization',
              label: '商家授權',
              path: `${config.publicUrl}/shop/authorization`,
              permission: permissions.VIEW__ADMIN_SHOP,
            },
          ],
        },
        {
          key: 'ScmDashboard',
          label: '訂單管理',
          icon: <ContainerOutlined />,
          children: [
            {
              key: 'Search',
              label: '訂單查詢',
              path: `${config.publicUrl}/order/orders`,
              permission: permissions.VIEW__ADMIN_ORDER,
            },
            {
              key: 'Issues',
              label: '訂單備註管理',
              path: `${config.publicUrl}/order/orders`,
              permission: permissions.VIEW__ADMIN_ORDER,
              ...issueStatusConfigs(['2']),
            },
            {
              key: 'Return',
              label: '退貨訂單',
              path: `${config.publicUrl}/order/returns`,
              permission: permissions.VIEW__ADMIN_RETURN,
            },
            {
              key: 'ReturnIssues',
              label: '退貨備註管理',
              path: `${config.publicUrl}/order/returns`,
              permission: permissions.VIEW__ADMIN_RETURN,
              ...issueStatusConfigs(['2'], 'return'),
            },
            {
              key: 'Stats',
              label: '單量統計',
              path: `${config.publicUrl}/order/stats`,
              permission: permissions.VIEW__ADMIN_DASHBOARD,
            },
          ],
        },
        {
          key: 'ScmSupportcase',
          label: '商談管理',
          icon: <ContactsOutlined />,
          children: [
            {
              key: 'Supportcase',
              label: '商談',
              path: `${config.publicUrl}/supportcase/supportcase`,
              permission: permissions.VIEW__ADMIN_SUPPORT_CASE,
            },
          ],
        },
        {
          key: 'Records',
          label: '紀錄管理',
          icon: <ContactsOutlined />,
          children: [
            {
              key: 'OtpOrderDownload',
              label: PAGE_TITLE.OPT_ORDER_DOWNLOAD,
              path: `${config.publicUrl}/records/otp-order-download`,
            },
            {
              key: 'AnnouncementConsent',
              label: PAGE_TITLE.ANNOUNCEMENT_CONSENT,
              path: `${config.publicUrl}/records/announcement-consent`,
            },
          ],
        },
        {
          key: 'B2cToolbox',
          label: 'B2C 工具箱',
          icon: <ToolOutlined />,
          children: [
            {
              key: 'B2cToolboxTools',
              label: '工具箱',
              path: `${config.publicUrl}/b2c-toolbox/tools`,
              permission: permissions.VIEW__ADMIN_B2C_TOOLBOX,
            },
          ],
        },
      ]
    : project === Project.SuppliersManagement
    ? [
        // suppliers-management
        {
          key: 'Homepage',
          label: '首頁',
          icon: <HomeOutlined />,
          children: [
            {
              key: 'Announcements',
              label: '公告',
              path: `${config.publicUrl}/homepage/announcements`,
            },
            {
              key: 'Backlogs',
              label: '待辦事項',
              path: `${config.publicUrl}/homepage/backlogs`,
            },
          ],
        },
        {
          key: 'SupplierAccounts',
          label: '用戶管理',
          icon: <UserOutlined />,
          children: [
            {
              key: 'Users',
              label: '使用者名單',
              path: `${config.publicUrl}/account/users`,
              permission: permissions.VIEW__SUPPLIER_USER,
            },
            {
              key: 'Roles',
              label: '角色管理',
              path: `${config.publicUrl}/account/roles`,
              permission: permissions.VIEW__SUPPLIER_ROLE,
            },
          ],
        },
        {
          key: 'SupplierSku',
          label: '商品管理',
          icon: <SolutionOutlined />,
          children: [
            {
              key: 'Sku',
              label: '轉單商品',
              path: `${config.publicUrl}/sku/skus`,
              permission: permissions.VIEW__SUPPLIER_SKU,
            },
          ],
        },
        {
          key: 'SupplierOrder',
          label: '訂單管理',
          icon: <ContainerOutlined />,
          children: [
            {
              key: 'Outbound',
              label: '訂單查詢',
              path: `${config.publicUrl}/order/orders`,
              permission: permissions.VIEW__SUPPLIER_OUTBOUND,
              params: {
                non_integrated_only: 'true',
              },
            },
            {
              key: 'Issues',
              label: '訂單備註管理',
              path: `${config.publicUrl}/order/orders`,
              permission: permissions.VIEW__SUPPLIER_OUTBOUND,
              ...issueStatusConfigs(['1']),
            },
            {
              key: 'Return',
              label: '退貨訂單',
              path: `${config.publicUrl}/order/returns`,
              permission: permissions.VIEW__SUPPLIER_RETURN,
            },
            {
              key: 'ReturnIssues',
              label: '退貨備註管理',
              path: `${config.publicUrl}/order/returns`,
              permission: permissions.VIEW__SUPPLIER_RETURN,
              ...issueStatusConfigs(['1'], 'return'),
            },
            {
              key: 'Stats',
              label: '單量統計',
              path: `${config.publicUrl}/order/stats`,
              permission: permissions.VIEW__SUPPLIER_DASHBOARD,
            },
          ],
        },
        {
          key: 'SupplierSupportcase',
          label: '商談管理',
          icon: <ContactsOutlined />,
          children: [
            {
              key: 'Supportcase',
              label: '商談',
              path: `${config.publicUrl}/supportcase/supportcase`,
              permission: permissions.VIEW__SUPPLIER_SUPPORT_CASE,
            },
          ],
        },
      ]
    : [];

function NavSidebar({ userVerified }) {
  const userPermissionMap = useUserPermissionMap();
  const location = useLocation();
  const { supplier_id } = useContext(UserContext);

  const menus = useMemo(() => {
    const subMenus: ReactNodeArray = [];
    for (let lv1 of sidebar) {
      const menuItems: ReactNodeArray = [];
      for (let lv2 of lv1.children) {
        const { permission, params, key, path, label, suppliers } = lv2;
        const isForbiddenSupplier = !_.isEmpty(suppliers) && !_.includes(suppliers, supplier_id);
        const showItem = !permission || !!userPermissionMap[permission];
        if (showItem && !isForbiddenSupplier) {
          const qs = _.isEmpty(params) ? '' : `?${stringifyUrlParams(params)}`;
          menuItems.push(
            <Menu.Item key={key}>
              <NavLink to={`${publicUrl}${path}${qs}`}>{label}</NavLink>
            </Menu.Item>
          );
        }
      }
      if (!!menuItems.length)
        subMenus.push(
          <SubMenu
            key={lv1.key}
            title={
              <span>
                {lv1.icon}
                <span>{lv1.label}</span>
              </span>
            }
          >
            {menuItems}
          </SubMenu>
        );
    }
    return subMenus;
  }, [userPermissionMap, supplier_id]);

  const { defaultOpenKey, selectedKey } = useMemo(() => {
    const urlParams = getUrlParamsBySearch(location.search);
    function getMenuMatchWeight({ params = {}, path, weigh }: SidebarSubMenu) {
      const isSamePath = matchPath(location.pathname, {
        path: `${publicUrl}${path}`,
        strict: true,
      });
      if (!isSamePath) return 0;

      const paramsWeight = _.isEmpty(params)
        ? 0
        : !!weigh
        ? weigh(urlParams, params)
        : _.transform(
            params,
            function (increment, value, q) {
              increment += _.isEqual(urlParams[q], value);
              return increment;
            },
            0
          );
      return 1 + paramsWeight;
    }

    let currentWeight = 0;
    let defaultOpenKey: string = '';
    let selectedKey: string = '';
    for (let lv1 of sidebar) {
      for (let lv2 of lv1.children) {
        const matchWeight = getMenuMatchWeight(lv2);
        if (matchWeight > currentWeight) {
          currentWeight = matchWeight;
          defaultOpenKey = lv1.key;
          selectedKey = lv2.key;
        }
      }
    }
    return { defaultOpenKey, selectedKey };
  }, [location]);

  return userVerified ? (
    <Menu
      mode="inline"
      defaultOpenKeys={!!defaultOpenKey ? [defaultOpenKey] : []}
      selectedKeys={!!selectedKey ? [selectedKey] : []}
      style={{ borderRight: 'none' }}
    >
      {menus}
    </Menu>
  ) : (
    <Card size="small" bordered={false}>
      <Skeleton
        active
        avatar
        title={{ width: '70%' }}
        paragraph={{ rows: 3, width: Array(3).fill('90%') }}
      />
    </Card>
  );
}

export default NavSidebar;
